import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';
import { FiTool, FiDatabase, FiSettings } from 'react-icons/fi';

export const Placeholder = ({ title, icon = FiTool }) => {
  return (
    <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="h-full flex flex-col justify-center items-center text-center p-6">
      <div className="w-20 h-20 rounded-sm bg-slate-900 border border-slate-800 flex items-center justify-center mb-6 neon-border relative">
        <div className="absolute inset-0 bg-cyan-500/5 animate-pulse"></div>
        <SafeIcon icon={icon} className="text-3xl text-cyan-500" />
      </div>
      <h2 className="text-xl font-bold text-slate-100 mb-2 uppercase tracking-tight">{title} Module</h2>
      <p className="text-slate-500 font-mono text-xs max-w-sm leading-relaxed">
        Access Restricted. This module requires elevated clearance or is currently synchronizing with the central site engine.
      </p>
      <div className="mt-8 grid grid-cols-2 gap-4 w-full max-w-xs">
        <div className="h-1 bg-slate-800 rounded-full overflow-hidden">
          <div className="h-full bg-cyan-500 w-2/3 animate-pulse"></div>
        </div>
        <div className="h-1 bg-slate-800 rounded-full overflow-hidden">
          <div className="h-full bg-yellow-500 w-1/3 animate-pulse"></div>
        </div>
      </div>
    </motion.div>
  );
};